<template>
  <el-tabs type="border-card">
    <el-tab-pane label="门禁设备" v-if="$route.query.tab != 'unBind'">
      <AccessControlDeviceOne />
    </el-tab-pane>
    <!-- <el-tab-pane label="未绑定门禁设备" v-if="!$route.query.carportId">
      <AccessControlDeviceTwo />
    </el-tab-pane> -->
  </el-tabs>
</template>

<script>
import AccessControlDeviceOne from "@/views/GarageManage/AccessControlDevice/AccessControlDeviceOne";
// import AccessControlDeviceTwo from "@/views/GarageManage/AccessControlDevice/AccessControlDeviceTwo";

export default {
  name: "AccessControlDevice",
  components: {
    // AccessControlDeviceTwo,
    AccessControlDeviceOne,
  },
};
</script>

<style scoped></style>
